import { useNavigate } from 'react-router-dom';

export const useApplyThenNavigate = () => {
  const navigate = useNavigate();

  const applyThenNavigate = async (fn: () => void, route: string) => {
    await new Promise<void>((resolve) => {
      fn();
      setTimeout(resolve, 0);
    });
    navigate(route);
  };

  return applyThenNavigate;
};